<main id="login-page">
    <div class="main-panel">
        <div *ngIf="hasSentResetPasswordRequest && canResetPassword" class="row">
            <div class="col-sm-3 col-xs-2 margin-bottom-20">
            </div>
            <div class="col-sm-6 col-xs-8 margin-bottom-20">
                <h3>Reset Password</h3>
                <form (ngSubmit)="resetPassword(resetPasswordForm)" #resetPasswordForm="ngForm">
                    <input class="form-control"  ngModel id="password" name="password" required email placeholder="New Password" type="password" value="">                                
                    <input class="form-control"  ngModel id="confirmPassword" name="confirmPassword" required placeholder="Confirm New Password" type="password" value="">
                    <button class="btn btn-block" type="submit">Change Password</button>
                </form>
            </div>
        </div>
        <div *ngIf="badToken" class="row">
            <div class="col-md-5 col-sm-12 margin-bottom-20">
                <h3>Cannot reset password from this email.  Please go to <a class="btn login-register-buttons margin-right-5 margin-bottom-5" [routerLink]="['/loginview']"><i class="fa fa-user login-register-text" aria-hidden="true"></i> Log in </a> screen and try to reset your password again</h3>
            </div>
        </div>   
    </div>
</main>